    export const setAgencyBody = (agencyData) => {
    let agencyBody = {shouldSearchInAcuite : false, shouldSearchInBrickwork : false, shouldSearchInCare : false, shouldSearchInCrisil : false, shouldSearchInIcra : false, shouldSearchInIR : false}
    if(agencyData.ACUITE !== undefined && agencyData.ACUITE !== null)
    {
        agencyBody.shouldSearchInAcuite = agencyData.ACUITE
    }
    if(agencyData.BRICKWORK !== undefined && agencyData.BRICKWORK !== null)
    {
        agencyBody.shouldSearchInBrickwork = agencyData.BRICKWORK
    }
    if(agencyData.CARE !== undefined && agencyData.CARE !== null)
    {
        agencyBody.shouldSearchInCare = agencyData.CARE
    }
    if(agencyData.CRISIL !== undefined && agencyData.CRISIL !== null)
    {
        agencyBody.shouldSearchInCrisil = agencyData.CRISIL
    }
    if(agencyData.ICRA !== undefined && agencyData.ICRA !== null)
    {
        agencyBody.shouldSearchInIcra = agencyData.ICRA
    }
    if(agencyData.INDIARATINGS !== undefined && agencyData.INDIARATINGS !== null)
    {
        agencyBody.shouldSearchInIR = agencyData.INDIARATINGS
    }
    return agencyBody
}

export const getMappedRatingData = (companyNameOnAgency) => {

    let ratingData = {
        acuiteAgencyCompanyName: "",
        acuiteDeepLink: "",
        brickworkAgencyCompanyName: "",
        brickworkDeepLink: "",
        careAgencyCompanyName: "",
        careDeepLink: "",
        crisilAgencyCompanyName: "",
        crisilDeepLink: "",
        icraAgencyCompanyName: "",
        icraDeepLink: "",
        irAgencyCompanyName: "",
        irDeepLink: ""
    }

    if (companyNameOnAgency !== undefined && companyNameOnAgency !== null) {
        if (Object.keys(companyNameOnAgency).length > 0) {
            if (companyNameOnAgency.ratingDataModel !== undefined && companyNameOnAgency.ratingDataModel !== null) {
                if (companyNameOnAgency.ratingDataModel.crisilRating !== undefined && companyNameOnAgency.ratingDataModel.crisilRating !== null) {
                    if (companyNameOnAgency.ratingDataModel.crisilRating.agencyCompanyName !== undefined && companyNameOnAgency.ratingDataModel.crisilRating.agencyCompanyName !== null) {
                        ratingData.crisilAgencyCompanyName = companyNameOnAgency.ratingDataModel.crisilRating.agencyCompanyName;
                    }
                }

                if (companyNameOnAgency.ratingDataModel.careRating !== undefined && companyNameOnAgency.ratingDataModel.careRating !== null) {
                    if (companyNameOnAgency.ratingDataModel.careRating.agencyCompanyName !== undefined && companyNameOnAgency.ratingDataModel.careRating.agencyCompanyName !== null) {
                        ratingData.careAgencyCompanyName = companyNameOnAgency.ratingDataModel.careRating.agencyCompanyName;
                    }
                }

                if (companyNameOnAgency.ratingDataModel.icraRating !== undefined && companyNameOnAgency.ratingDataModel.icraRating !== null) {
                    if (companyNameOnAgency.ratingDataModel.icraRating.agencyCompanyName !== undefined && companyNameOnAgency.ratingDataModel.icraRating.agencyCompanyName !== null) {
                        ratingData.icraAgencyCompanyName = companyNameOnAgency.ratingDataModel.icraRating.agencyCompanyName;
                    }
                }

                if (companyNameOnAgency.ratingDataModel.acuiteRating !== undefined && companyNameOnAgency.ratingDataModel.acuiteRating !== null) {
                    if (companyNameOnAgency.ratingDataModel.acuiteRating.agencyCompanyName !== undefined && companyNameOnAgency.ratingDataModel.acuiteRating.agencyCompanyName !== null) {
                        ratingData.acuiteAgencyCompanyName = companyNameOnAgency.ratingDataModel.acuiteRating.agencyCompanyName;
                    }
                }

                if (companyNameOnAgency.ratingDataModel.brickworksRating !== undefined && companyNameOnAgency.ratingDataModel.brickworksRating !== null) {
                    if (companyNameOnAgency.ratingDataModel.brickworksRating.agencyCompanyName !== undefined && companyNameOnAgency.ratingDataModel.brickworksRating.agencyCompanyName !== null) {
                        ratingData.brickworkAgencyCompanyName = companyNameOnAgency.ratingDataModel.brickworksRating.agencyCompanyName;
                    }
                }

                if (companyNameOnAgency.ratingDataModel.irRating !== undefined && companyNameOnAgency.ratingDataModel.irRating !== null) {
                    if (companyNameOnAgency.ratingDataModel.irRating.agencyCompanyName !== undefined && companyNameOnAgency.ratingDataModel.irRating.irRating !== null) {
                        ratingData.irAgencyCompanyName = companyNameOnAgency.ratingDataModel.irRating.agencyCompanyName;
                    }
                }
            }
        }
    }
    return ratingData
}


export const getSearchedRatingData = (counterpartyId, searchedCompanyNames) => {
    let searchedRatingData = {
     crisilList : [],
     icraList : [],
     acuiteList : [],
     careList : [],
     brickworkList : [],
     irList : [],
     message : []
    }
    if (searchedCompanyNames !== undefined && searchedCompanyNames !== null) {
        if (Object.keys(searchedCompanyNames).length > 0) {
            if(counterpartyId === searchedCompanyNames.counterpartyId)
            {
            if (searchedCompanyNames.crisilAgencyCompanyNames !== null && searchedCompanyNames.crisilAgencyCompanyNames !== undefined) {
                searchedRatingData.crisilList = searchedCompanyNames.crisilAgencyCompanyNames;
            }
            if (searchedCompanyNames.icraAgencyCompanyNames !== null && searchedCompanyNames.icraAgencyCompanyNames !== undefined) {
                searchedRatingData.icraList = searchedCompanyNames.icraAgencyCompanyNames;
            }
            if (searchedCompanyNames.acuiteAgencyCompanyNames !== null && searchedCompanyNames.acuiteAgencyCompanyNames !== undefined) {
                searchedRatingData.acuiteList = searchedCompanyNames.acuiteAgencyCompanyNames;
            }
            if (searchedCompanyNames.careAgencyCompanyNames !== null && searchedCompanyNames.careAgencyCompanyNames !== undefined) {
                searchedRatingData.careList = searchedCompanyNames.careAgencyCompanyNames;
            }
            if (searchedCompanyNames.brickworkAgencyCompanyNames !== null && searchedCompanyNames.brickworkAgencyCompanyNames !== undefined) {
                searchedRatingData.brickworkList = searchedCompanyNames.brickworkAgencyCompanyNames;
            }
            if (searchedCompanyNames.irAgencyCompanyNames !== null && searchedCompanyNames.irAgencyCompanyNames !== undefined) {
                searchedRatingData.irList = searchedCompanyNames.irAgencyCompanyNames;
            }
            if (searchedCompanyNames.message !== null && searchedCompanyNames.message !== undefined) {
                searchedRatingData.message = searchedCompanyNames.message;
            }
        }
        }
    }
    return searchedRatingData
}